export default {
    data: function () {
        return {
            typingWhisperTimeout: null,
            sendWhisper: null,
            typingUsers: [],
        }
    },
    methods: {
        handleWhisper({ id, name }) {
            let found = this.typingUsers.find((user) => user.id == id)
            if (!found) {
                found = {
                    id: id,
                    name: name,
                    timeoutId: null,
                }
                this.typingUsers.push(found)
            }

            if (found.timeoutId != null) {
                clearTimeout(found.timeoutId)
            }

            found.timeoutId = setTimeout(() => {
                this.typingUsers = this.typingUsers.filter(
                    (user) => user.id != id
                )
            }, 5000)
        },

        whisper(id, name, params) {
            if (!this.sendWhisper && this.echoChannel) {
                this.sendWhisper = true
                this.echoChannel.whisper('typing', {
                    id: id,
                    name: name,
                    ...params,
                })
                this.typingWhisperTimeout = setTimeout(() => {
                    this.sendWhisper = false
                }, 1000)
            }
        },

        checkIfTypingUserPosted(user_id) {
            let found = this.typingUsers.find((user) => user.id == user_id)
            if (found && found.timeoutId != null) {
                clearTimeout(found.timeoutId)
                setTimeout(() => {
                    this.typingUsers = this.typingUsers.filter(
                        (user) => user.id != user_id
                    )
                }, 500)
            }
        },
    },
}
